// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------------------------------------------------
    Datepicker body
   ------------------------------------------------- */
.air-datepicker-body {
  transition: all var(--adp-transition-duration) var(--adp-transition-ease);
}
.air-datepicker-body.-hidden- {
  display: none;
}

/*  Day names
   ------------------------------------------------- */
.air-datepicker-body--day-names {
  display: grid;
  grid-template-columns: repeat(7, var(--adp-day-cell-width));
  margin: 0 0 10px 0;
}

.air-datepicker-body--day-name {
  color: var(--adp-day-name-color);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
  text-transform: capitalize;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.air-datepicker-body--day-name.-clickable- {
  cursor: pointer;
}
.air-datepicker-body--day-name.-clickable-:hover {
  color: var(--adp-day-name-color-hover);
}

/*  Cells container
   ------------------------------------------------- */
.air-datepicker-body--cells {
  display: grid;
}
.air-datepicker-body--cells.-days- {
  grid-template-columns: repeat(7, var(--adp-day-cell-width));
  grid-auto-rows: var(--adp-day-cell-height);
}
.air-datepicker-body--cells.-months- {
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: var(--adp-month-cell-height);
  padding: 0 10px;
}
.air-datepicker-body--cells.-years- {
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: var(--adp-year-cell-height);
  padding: 0 10px;
}`, "",{"version":3,"sources":["webpack://./src/libs/air-date-picker/src/datepickerBody.scss"],"names":[],"mappings":"AAAA;;sDAAA;AAIA;EACE,yEAAA;AAAF;AAEE;EACE,aAAA;AAAJ;;AAKA;sDAAA;AAGA;EACE,aAAA;EACA,2DAAA;EACA,kBAAA;AAHF;;AAMA;EACE,gCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHF;AAIE;EACE,eAAA;AAFJ;AAII;EACE,sCAAA;AAFN;;AAOA;sDAAA;AAGA;EACE,aAAA;AALF;AAME;EACE,2DAAA;EACA,0CAAA;AAJJ;AAOE;EACE,qCAAA;EACA,4CAAA;EACA,eAAA;AALJ;AAQE;EACE,qCAAA;EACA,2CAAA;EACA,eAAA;AANJ","sourcesContent":["/* -------------------------------------------------\n    Datepicker body\n   ------------------------------------------------- */\n\n.air-datepicker-body {\n  transition: all var(--adp-transition-duration) var(--adp-transition-ease);\n\n  &.-hidden- {\n    display: none;\n  }\n}\n\n\n/*  Day names\n   ------------------------------------------------- */\n\n.air-datepicker-body--day-names {\n  display: grid;\n  grid-template-columns: repeat(7, var(--adp-day-cell-width));\n  margin: 0 0 10px 0;\n}\n\n.air-datepicker-body--day-name {\n  color: var(--adp-day-name-color);\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  text-align: center;\n  text-transform: capitalize;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  &.-clickable- {\n    cursor: pointer;\n\n    &:hover {\n      color: var(--adp-day-name-color-hover);\n    }\n  }\n}\n\n/*  Cells container\n   ------------------------------------------------- */\n\n.air-datepicker-body--cells {\n  display: grid;\n  &.-days- {\n    grid-template-columns: repeat(7, var(--adp-day-cell-width));\n    grid-auto-rows: var(--adp-day-cell-height);\n  }\n\n  &.-months- {\n    grid-template-columns: repeat(4, 1fr);\n    grid-auto-rows: var(--adp-month-cell-height);\n    padding: 0 10px;\n  }\n\n  &.-years- {\n    grid-template-columns: repeat(4, 1fr);\n    grid-auto-rows: var(--adp-year-cell-height);\n    padding: 0 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
